<template>
  <div>
    <base-profile />
    <div class="container-profile pb-5">
      <profile-mi-credito />
    </div>
  </div>
</template>
<script>
import BaseProfile from '@/components/profile/BaseProfile'
import ProfileMiCredito from '@/components/profile/ProfileMiCredito'
export default {
  components: { BaseProfile, ProfileMiCredito },
  // mounted() {
  //     document.title = 'Perfil | DEREK Tienda Online'
  //     this.$gtag.pageview(this.$route.fullPath);
  // },
}
</script>
